import { isKeyframesTarget } from "../../animation/utils/is-keyframes-target.mjs";
import { resolveVariant } from "./resolve-dynamic-variants.mjs";
import { motionValue } from "../../../../../../../motion-dom@12.10.5/external/motion-dom/dist/es/value/index.mjs";
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function resolveFinalValueInKeyframes(v) {
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
  target = { ...target, ...transitionEnd };
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
export {
  setTarget
};
